import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { ExitProofLogs } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  lrn: string;
  proofOfExit: ExitProofLogs;
}

export const useSendProofOfExit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ lrn, proofOfExit }: HookProps) => {
      await request({
        path: `idms/send-proof-of-exit`,
        method: 'POST',
        authenticate: true,
        dataObject: { LRN: lrn, proofOfExit },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['declaration'] });
      toast.success('Proof of exit sent successfully!');
    },
    onError: (error) => {
      showErrorToast(error, `Error sending proof of exit!`);
    },
  });
};
